module.exports = __webpack_public_path__ + "static/img/v73Bg-p.474e68c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v73Bg-p.png
// module id = aT7k
// module chunks = 1